<template lang="haml">
  %v-flex.xs12.md10.offset-md1.xl8.offset-xl2
    %v-card{ "v-if": "order", ":data-id": "order.id" }
      %v-card-title
        .center-align.full-width.pt-2.pb-1
          %div{ "v-if": "isDelivered" }
            %v-icon.blue--text{ size: "150px" } mdi-check
            %h1.center-align Your Gung-Ho order has been delivered

          %div{ "v-else-if": "isShipped" }
            %v-icon.blue--text{ size: "150px" } mdi-truck
            %h1.center-align Your Gung-Ho order has shipped

          %div{ "v-else": true }
            %v-icon.blue--text{ size: "150px" } mdi-thumb-up
            %h1.center-align Thank you for your Gung-Ho order

      %v-card-text.px-5.pb-5
        %v-stepper{ "v-model": "steps", "alt-labels": true }
          %v-stepper-header
            %v-stepper-step{ step: 1, ":complete": "isOrdered" }
              %template{ "v-if": "isOrdered" }
                ORDERED
                %div {{order.ordered_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY hh:mm A [PT]')}}
                %v-btn.mt-3{ color: 'primary', large: true, ":to": "'/reorder/' + order.id" } REORDER
              %template{ "v-else": true }
                STARTED
            %v-divider
            %v-stepper-step{ step: 2, ":complete": "isProduction" }
              %template{ "v-if": "isShipped" }
                SHIPPED
                %div {{order.shipped_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY hh:mm A [PT]')}}
                %v-btn.mt-3{ color: 'primary', large: true, ":href": "order.shipping_status.shipping_link", target: "_blank" }
                  Track
              %template{ "v-else-if": "isProduction" }
                PRODUCTION
                %div {{order.processed_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY hh:mm A [PT]')}}
                %v-btn.mt-3{ disabled: true, large: true, target: "_blank" } Track
              %template{ "v-else": true }
                PRODUCTION
            %v-divider
            %v-stepper-step{ step: 3, ":complete": "isDelivered" }
              %template{ "v-if": "isDelivered" }
                DELIVERED
                %div {{order.delivered_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY hh:mm A [PT]')}}
                %v-btn.mt-3{ color: 'primary', large: true, ":href": 'feedbackUrl', target: '_blank' }
                  Feedback
              %template{ "v-else-if": "isExpected" }
                EXPECTED
                %div {{order.expected_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY hh:mm A [PT]')}}
                %v-btn.mt-3{ disabled: true, large: true, ":href": 'feedbackUrl', target: '_blank' }
                  Feedback
              %template{ "v-else": true }
                DELIVERED
                %div{ style: "height: 22px" }
                %v-btn.mt-3{ disabled: true, large: true, ":href": 'feedbackUrl', target: '_blank' }
                  Feedback

        %v-layout
          %v-flex.sm12.md6
            %h2.semibold Order Number {{order.site_code}}{{order.id}}
          %v-flex.sm12.md6
            %h2.semibold Order Placed {{order.created_at | moment('timezone', 'America/Los_Angeles', 'MM/DD/YYYY hh:mm A [PT]')}}

        %v-layout
          %v-flex.sm12.md6
            %h3.semibold Shipping Information
            %display-address{ "v-if": "order", ":data": "order.shipping_info" }
          %v-flex.sm12.md6
            %h3.semibold Billing Information
            %display-address{ "v-if": "order", ":data": "order.billing_info" }

        %table.fancy.mt-5
          %thead
            %tr
              %th.left-side{ width: 1 }
              %th{ width: 1 }
              %th.left-align.nowrap Item Description
              %th.right-align.hidden-on-sm-only{ width: 1 } Qty
              %th.right-align.nowrap.hidden-on-md-and-down{ width: 1 } Unit Price
              %th.right-align.nowrap{ width: 1 }
                %span.hidden-on-md-and-down Item Total
          %tbody
            %tr{ "v-for": "(item, index) in order.items" }
              %td.left-side{ width: 1 }
              %td.center-align{ width: 100 }
                %img.responsive-img{ ":src": "item.file.thumbs.medium", alt: "" }
              %td
                %item-description{ ":item": "item" }
              %td.right-align.hide-on-small-only {{item.quantity}}
              %td.right-align.hide-on-med-and-down {{item.price | currency}}
              %td.right-align {{(item.price * item.quantity) | currency}}

        %v-layout
          %v-flex.xs12.md7
            %br
            %b.semibold Shipping Method:
            %span {{order.shipping_method_long_name}}
            %br
            %b.semibold Tracking Number:
            %template{ "v-if": "isShipped" }
              %a{ ":href": "order.shipping_status.shipping_link", target: '_blank' }
                %span {{order.shipping_status.tracking_number}}
            %template{ "v-else": true }
              Provided when your order ships
            %div.red--text{ "v-if": "hasDiscount && this.order.process === 'Mpupload'" }
              %br
              We hope you enjoy your complimentary copy from Masterplans.

          %v-flex.xs12.md5
            %table.plain.totals.right
              %tbody
                %tr
                  %th.right-align.normal Order Subtotal
                  %td.right-align{ width: 1 } {{order.subtotal | currency}}
                %tr
                  %th.right-align Shipping &amp; Processing
                  %td.right-align {{order.total_shipping | currency}}
                %tr
                  %th.right-align Sales Tax
                  %td.right-align {{order.total_tax | currency}}
                %tr{ "v-if": "order.total_discount > 0" }
                  %th.right-align {{discountText}}
                  %td.right-align{ ":class": "hasDiscount"} {{order.total_discount | currency}}
                %tr
                  %th.semibold.right-align Order Total
                  %td.semibold.right-align {{order.total_price | currency}}

        %v-layout.mt-5{ "v-if": "order.total_price > 0" }
          %v-flex.xs12
            %b.semibold
              The Order Total of {{order.total_price | currency}} was charged
              to your Credit Card with Gung-Ho Company as the Merchant.
</template>

<script>
  import api from '@/api/gungho'
  import DisplayAddress from '../widgets/display-address'
  import ItemDescription from '../widgets/item-description'

  export default {
    components: {
      displayAddress: DisplayAddress,
      itemDescription: ItemDescription
    },

    data () {
      return {
        steps: 1,
        order: false
      }
    },

    metaInfo () {
      return {
        title: `Order ${this.order ? `${this.order.site_code}${this.order.id}` : ''}`
      }
    },

    computed: {
      feedbackUrl () {
        return process.env.CONTACT_URL + '?sub=Feedback / Other'
      },

      hasDiscount () {
        return { 'red--text': this.order.total_discount > 0 }
      },

      isOrdered () {
        return this.order.ordered_at !== '' && this.order.ordered_at !== null
      },

      isProduction () {
        return this.order.processed_at !== '' && this.order.processed_at !== null
      },

      isShipped () {
        return this.order.shipped_at !== '' && this.order.shipped_at !== null
      },

      isExpected () {
        return this.order.expected_at !== '' && this.order.expected_at !== null
      },

      isDelivered () {
        return this.order.delivered_at !== '' && this.order.delivered_at !== null
      },

      discountText () {
        if (this.order.process === 'Mpupload') {
          return 'Masterplans Discount'
        } else {
          return 'Discount'
        }
      }
    },

    beforeMount () {
      api.order(this.$route.params.id).then((data) => {
        this.order = data.order
      })
    }
  }
</script>



// WEBPACK FOOTER //
// show.vue?ae704756